/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {ActivityFeedEventRenderFactory} from "./ActivityFeedEventRenderFactory";
import {ActivityFeedItem} from "./ActivityFeedItem";
import React from "react";
import {service as ActivityTypeService} from "../../../Services/ActivityTypeService";
import {usePrimeCache} from "../../../Hooks/ServiceHooks";
import {useErrorBoundary} from "use-error-boundary";
import {ActivityFeedErrorItem} from "./ActivityFeedErrorItem";

export const ActivityFeedGroup = (props) => {
    
    const {
        title,
        events,
    } = props;
    
    usePrimeCache(ActivityTypeService);
    const { ErrorBoundary } = useErrorBoundary();
    
    const eventTypes = ActivityTypeService.CachedValues()?.result;
    
    return <div className="sb-activity-feed-group">
        <h3 className="sb-activity-feed-group-header">
            {title}
        </h3>
        {
            events.map(y => {
                const eventContext = ActivityFeedEventRenderFactory.getContextForActivity(eventTypes, y);
                
                if (eventContext.valid) {
                    return <ErrorBoundary
                        key={y.contextNodeActivityId}
                        renderError={ActivityFeedErrorItem}
                        onDidCatch={(error, errorInfo) => {
                            console.log("Error rendering activity feed item:", error, errorInfo);
                        }}
                    >
                        <ActivityFeedItem
                            key={y.contextNodeActivityId}
                            Event={y}
                            title={eventContext.title}
                            description={eventContext.description}
                            secondaryDescription={eventContext.secondaryDescription}
                        />
                    </ErrorBoundary>
                } else {
                    return null;
                }
            })
        }
    </div>;
}
